export default [
  {
    path: "/share",
    name: "share",
    meta: {
      title: "职位分享"
    },
    component: () => import("./share.vue")
  }
];
